<script>
import Checkbox from 'primevue/checkbox';
import Tooltip from 'primevue/tooltip';
import { h, withDirectives } from 'vue';

export default {
    name: 'ETableSelectAllHeader',

    props: {
        state: {
            type: String,
            default: 'none',
            validator: value => ['none', 'some', 'all'].includes(value),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        tooltip: {
            type: String,
            default: '',
        },
    },

    emits: ['toggle'],

    computed: {
        hasTooltip() {
            return this.disabled && Boolean(this.tooltip);
        },

        hoverCapable() {
            if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
                return true;
            }

            return window.matchMedia('(hover: hover)').matches;
        },
    },

    methods: {
        onChange() {
            if (!this.disabled) {
                this.$emit('toggle');
            }
        },
    },

    render() {
        const checkbox = h(Checkbox, {
            modelValue: this.state === 'all',
            indeterminate: this.state === 'some',
            binary: true,
            disabled: this.disabled,
            'aria-label': 'Select all',
            class: this.disabled ? 'e-select-all-header__checkbox--locked' : null,
            onChange: this.onChange,
        });

        const spanProps = { class: 'e-select-all-header' };

        if (!this.hasTooltip) {
            return h('span', spanProps, [checkbox]);
        }

        const modifiers = this.hoverCapable ? { top: true } : { top: true, focus: true };

        if (!this.hoverCapable) {
            spanProps.tabindex = 0;
        }

        const tooltipValue = { value: this.tooltip, class: 'e-select-all-header__tooltip' };

        return withDirectives(h('span', spanProps, [checkbox]), [[Tooltip, tooltipValue, undefined, modifiers]]);
    },
};
</script>

<style lang="scss">
.e-select-all-header {
    display: inline-flex;

    .e-select-all-header__checkbox--locked {
        pointer-events: none;
    }
}

.e-select-all-header__tooltip.p-tooltip {
    max-width: 20rem;

    .p-tooltip-text {
        max-width: 20rem;
    }
}
</style>
